import { useContext, useEffect, useState } from "react";
import "./Products.css";
import { ConfigContext } from "../../../assets/contexts/configContext";
import ProductCard from "../ProductCard/ProductCard";
import Filters from "./Filters/Filters";
import FilterBox from "./FilterBox/FilterBox";
import { FiltersContext } from "../../../assets/contexts/filtersContext";
import useWindowSize from "../../../assets/hooks/useWindowSize";
import { FiltersIcon } from "../../../assets/icons/icons";
import MiniPreloader from "../../MiniPreloader/MiniPreloader";
import CategoryCard from "../CategoryCard/CategoryCard";
import mainApi from "../../../assets/api/MainApi";
import {
  AUDEMARS_CATEGORY_LINK,
  BIRKIN_CATEGORY_LINK,
  BOLIDE_A_BRAC_CATEGORY_LINK,
  BRIDE_A_BRAC_CATEGORY_LINK,
  BVLGARY_CATEGORY_LINK,
  CARTIER_CATEGORY_LINK,
  CONSTANCE_CATEGORY_LINK,
  EVELYNE_TPM_CATEGORY_LINK,
  FINE_ART_CATEGORY_LINK,
  FP_JOURNE_CATEGORY_LINK,
  FRANK_MULLER_CATEGORY_LINK,
  HAC_A_DOS_CATEGORY_LINK,
  HERBAG_ZIP_CATEGORY_LINK,
  HERMES_BAGS_CATEGORY_LINK,
  HUBLOT_CATEGORY_LINK,
  JEWELRY_CATEGORY_LINK,
  KELLY_CATEGORY_LINK,
  PATEK_PHILIPPE_CATEGORY_LINK,
  PICOTIN_LOCK_CATEGORY_LINK,
  RICHARD_MILE_CATEGORY_LINK,
  ROLEX_CATEGORY_LINK,
  WATCHES_CATEGORY_LINK,
} from "../../../assets/utils/constants";

import ProductCardHorizontal from "../ProductCardHorizontal/ProductCardHorizontal";

const DESIRED_CATALOG_ZERO_LEVEL_ORDER = [
  WATCHES_CATEGORY_LINK,
  JEWELRY_CATEGORY_LINK,
  HERMES_BAGS_CATEGORY_LINK,
  FINE_ART_CATEGORY_LINK,
];

const DESIRED_CATALOG_WATCHES_ORDER = [
  ROLEX_CATEGORY_LINK,
  AUDEMARS_CATEGORY_LINK,
  PATEK_PHILIPPE_CATEGORY_LINK,
  RICHARD_MILE_CATEGORY_LINK,
  CARTIER_CATEGORY_LINK,
  BVLGARY_CATEGORY_LINK,
  FRANK_MULLER_CATEGORY_LINK,
  HUBLOT_CATEGORY_LINK,
  FP_JOURNE_CATEGORY_LINK,
  BIRKIN_CATEGORY_LINK,
  KELLY_CATEGORY_LINK,
  CONSTANCE_CATEGORY_LINK,
  HERBAG_ZIP_CATEGORY_LINK,
  EVELYNE_TPM_CATEGORY_LINK,
  HAC_A_DOS_CATEGORY_LINK,
  PICOTIN_LOCK_CATEGORY_LINK,
  BRIDE_A_BRAC_CATEGORY_LINK,
  BOLIDE_A_BRAC_CATEGORY_LINK,
];

function Products({ items, path, isSearch, category, preloaders, levels }) {
  const { width } = useWindowSize();
  const config = useContext(ConfigContext);
  const { cardTokens, initialConstants } = config;
  const { cards_in_line } = cardTokens;
  const { USING_FILTERS, SHOP_ID_FOR_API } = initialConstants;
  // const USING_FILTERS = true

  const { filterValues, handleOpenFilterPopup, isLoading } =
    useContext(FiltersContext) || {};

  const IS_FILTERS_AVAILIBLE = USING_FILTERS && filterValues ? true : false;

  // Local search state for API-based search inside selected category
  const [categorySearchValue, setCategorySearchValue] = useState("");
  const [categorySearchItems, setCategorySearchItems] = useState(null);
  const [isCategorySearchLoading, setIsCategorySearchLoading] = useState(false);
  const [isCategorySearchActive, setIsCategorySearchActive] = useState(false);

  // Reset category search when category changes
  useEffect(() => {
    setCategorySearchValue("");
    setCategorySearchItems(null);
    setIsCategorySearchActive(false);
    setIsCategorySearchLoading(false);
  }, [category?._id]);

  const cardsInLine =
    cards_in_line - (width > 900 && IS_FILTERS_AVAILIBLE ? 1 : 0);


  const effectiveItems = isCategorySearchActive && categorySearchItems
    ? categorySearchItems
    : items;

  const effectiveData = effectiveItems?.data || [];

  const showItemsLoader = isLoading || isCategorySearchLoading;

  function handleCategorySearchSubmit(e) {
    e.preventDefault();
    const trimmed = categorySearchValue.trim();

    if (!trimmed) {
      // Clear search: show original category items again
      setIsCategorySearchActive(false);
      setCategorySearchItems(null);
      return;
    }

    const payload = {
      shop_id: SHOP_ID_FOR_API,
      limit: 25,
      string: trimmed,
      content_types: ["published"],
    };

    if (category && category._id) {
      payload.category_id = category._id;
    }

    setIsCategorySearchLoading(true);
    setIsCategorySearchActive(true);

    mainApi
      .getSearch(payload)
      .then((res) => {
        console.log("Category search result", res);
        setCategorySearchItems(res);
      })
      .catch((err) => {
        console.log(err);
        setCategorySearchItems({ data: [], is_more: false });
      })
      .finally(() => {
        setIsCategorySearchLoading(false);
      });
  }

  function handleCategorySearchClear() {
    setCategorySearchValue("");
    setIsCategorySearchActive(false);
    setCategorySearchItems(null);
  }


  return (
    <div className={`products ${IS_FILTERS_AVAILIBLE && !categorySearchItems ? 'products_with-filters' : ''}`}>
      {IS_FILTERS_AVAILIBLE && !categorySearchItems ?
        <div className='products__filters'>
          <FilterBox />
        </div>
        : null}

      {IS_FILTERS_AVAILIBLE && !categorySearchItems ?
        <div className="products__heading">
          <button className='products__filters-btn' type="button" onClick={handleOpenFilterPopup}>
            <FiltersIcon
              mainClassName={'products__filters-btn-icon'}
              strokeClassName={'products__filters-btn-icon-stroke'}
            />
          </button>
        </div>

        : null}

      <div style={{ width: '100%' }}>
        {!isSearch && (!category?.categories || category?.categories?.length === 0) && (
          <div className="products__search">
            <form
              className="products__search-bar"
              onSubmit={handleCategorySearchSubmit}
            >
              <div className="products__search-input-wrapper">
                <input
                  type="text"
                  className="products__search-input"
                  placeholder="Search in this category"
                  value={categorySearchValue}
                  onChange={(e) => {
                    setCategorySearchValue(e.target.value)
                    const trimmed = e.target.value.trim();

                    if (!trimmed) {
                      // Clear search: show original category items again
                      setIsCategorySearchActive(false);
                      setCategorySearchItems(null);
                      return;
                    }
                  }}
                />
                {categorySearchValue && (
                  <button
                    type="button"
                    className="products__search-clear"
                    onClick={handleCategorySearchClear}
                    aria-label="Clear search"
                  >
                    ×
                  </button>
                )}
              </div>
              <button
                type="submit"
                className="products__search-button"
                disabled={!categorySearchValue.trim()}
              >
                Search
              </button>
            </form>
          </div>
        )}

        {!preloaders.subcategories ?
          category && category.categories && category.categories.length > 0 ?
            <div className="catalog__categories-inside">
              {category._id === null ?
                category.categories
                  .filter((item) => DESIRED_CATALOG_ZERO_LEVEL_ORDER.includes(item.translit_name))
                  .sort((a, b) => {
                    return (
                      DESIRED_CATALOG_ZERO_LEVEL_ORDER.indexOf(a.translit_name) -
                      DESIRED_CATALOG_ZERO_LEVEL_ORDER.indexOf(b.translit_name)
                    );
                  })
                  .map((cat, i) => (
                    <CategoryCard
                      levels={levels}
                      category={cat}
                      categories={category.categories}
                      i={i}
                      key={cat._id || cat.id || cat.slug || i}
                    />
                  ))
                :
                category.categories
                  .sort((a, b) => {
                    return (
                      DESIRED_CATALOG_WATCHES_ORDER.indexOf(a.translit_name) -
                      DESIRED_CATALOG_WATCHES_ORDER.indexOf(b.translit_name)
                    );
                  })
                  .map((cat, i) => (
                    <CategoryCard
                      levels={levels}
                      category={cat}
                      categories={category.categories}
                      i={i}
                      key={cat._id || cat.id || cat.slug || i}
                    />
                  ))}
            </div>
            : null
          :
          <div className="catalog__categories-preloader">
            <MiniPreloader />
          </div>
        }


        {!isLoading ?
          items?.data?.length > 0
            ?
            <div
              className={`products__items products__items_cards-in-line-${cardsInLine} ${isSearch ? 'products__items_search' : ''}`}
            >
              {effectiveData.map((item) => (
                <ProductCard
                  item={item}
                  key={`catalog_products_item_${item._id}`}
                  path={path}
                />
              ))}

            </div>
            :
            <div className="products__items-empty">
              <p>
                {isCategorySearchActive && categorySearchValue.trim()
                  ? `No results found for "${categorySearchValue.trim()}"`
                  : "No results found for your query"}
              </p>

            </div>
          :
          <div className="products__items-preloader">
            <MiniPreloader />
          </div>
        }
      </div>

    </div >
  );
}

export default Products;
